import { Component, OnInit } from '@angular/core';
import { AuthService } from '@kodit/core/services';
import { ActivatedRoute, Router } from '@angular/router';
import { KORISNICKA_PODRSKA_MOBILE, KORISNICKA_PODRSKA_MOBILE_HREF } from "@kodit/core/shared";

@Component({
  selector: 'kodit-pretplata-page',
  templateUrl: './pretplata-page.component.html',
  styleUrls: ['./pretplata-page.component.scss'],
})
export class PretplataPageComponent implements OnInit {
  /** Props */
  isInactive: boolean;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _route: ActivatedRoute
  ) {
    this.isInactive = !this._authService.getIsTenantActive;
  }

  ngOnInit(): void {}

  goToPaketi() {
    this._route.snapshot.data.subExpired
      ? this._router.navigate(['expired', 'paketi']).then()
      : this._router.navigate(['pretplata', 'paketi']).then();
  }

  public readonly KORISNICKA_PODRSKA_MOBILE_HREF = KORISNICKA_PODRSKA_MOBILE_HREF;
  public readonly KORISNICKA_PODRSKA_MOBILE = KORISNICKA_PODRSKA_MOBILE;
}
